// extracted by mini-css-extract-plugin
module.exports = {"contents":"fu-z","sectionHeading":"gu-z"};